import axios from '@/plugins/axios.js'

// 升级
export const upgrade = (params) => axios.post('/common/upgrade', params)